// app/javascript/controllers/expandable_card_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "content" ]

  connect() {
    }

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    const button = this.element.querySelector("button")
    button.textContent = this.contentTarget.classList.contains("hidden") ? "Mehr Informationen" : "Schließen"
  }
}